import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {
      saveRequestState: 0, // 0(未保存)，1(保存中)，2(保存成功)，3(保存失败)
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail"]),
    ...mapGetters("constant", ["getApplyStepList"]),
  },
  methods: {
    // 检查url是否携带参数id
    checkPathQueryHasId() {
      const query = this.$route.query;
      if (!query.id) {
        // 给出提示：缺少参数
        this.$message({
          message: this.$t("common.error.scarce"),
          type: "error",
          duration: 1000,
          onClose: () => {
            this.saveRequestState = 2;
            this.$router.replace("/");
          },
        });
      }
    },
    // 检查当前页面的申请步骤是否存在
    checkCurrentPageHasApplyStep() {
      const path = this.$route.path;
      const currentData = this.getApplyStepList().find(item => item.currentPath == path);
      if (!currentData) {
        this.$message({
          message: this.$t("common.error.stepNone"),
          type: "warning",
          duration: 1000,
          onClose: () => {
            this.saveRequestState = 2;
            this.$router.replace("/");
          },
        });
      }
    },
    // 检查当前页面的申请状态能否进入该页面
    checkCurrentPageSupportApplymentStatus() {
      const currentStepPath = this.$route.path;
      // 获取当前页申请状态
      const applymentStatus = this.applymentDetail.applymentStatus || "";
      // 获取当前页支持的申请状态
      const supportApplymentStatusMap = this.getApplyStepList().find(item => item.currentPath == currentStepPath)?.supportApplymentStatusMap;
      if (supportApplymentStatusMap) {
        const list = supportApplymentStatusMap?.list || [];
        const violateMessage = supportApplymentStatusMap?.violateMessage || "";
        // 如果当前页不支持当前申请状态，弹出警告消息并跳转首页
        if (!list.includes(applymentStatus)) {
          this.$message({
            message: this.$t(violateMessage),
            type: "warning",
            duration: 1000,
            onClose: () => {
              this.saveRequestState = 2;
              this.$router.replace("/");
            },
          });
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.saveRequestState == 2) {
      // 保存成功，跳转页面
      next();
    } else {
      next(false);
      setTimeout(() => {
        // 离开将丢失已编辑的内容，确定离开吗？
        this.$confirm(this.saveRequestState == 1 ? this.$t("common.hint.unfinished") : this.$t("common.hint.leave"), this.$t("common.hint.title"), {
          type: "warning",
        })
          .then(() => {
            next();
          })
          .catch(() => {});
      });
    }
  },
};
